import PerspectiveSelection from './PerspectiveSelection';
import { resetScope } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import type { AppState, AppThunkDispatch } from 'src/store';
import { connect } from 'react-redux';
import serviceContainer from 'src/ServiceContainer';
import { resetNavigation } from '../NavigationShell/NavigationShell.slice';
import type { DispatchProps, StateProps } from './PerspectiveSelection.types';

function mapStateToProps(state: AppState): StateProps {
  return {
    darkMode: state.uiPose.themeMode,
  };
}

function mapDispatchToProps(dispatch: AppThunkDispatch): DispatchProps {
  return {
    resetScope() {
      dispatch(resetScope());
      dispatch(resetNavigation());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PerspectiveSelection(serviceContainer.configService));
